// Copyright (c) 2022 by Move Closer

import { RoutesFactory } from '@movecloser/front-core'
import { RouteConfig } from 'vue-router'

import { buildStaticRoutesDefinitions, StaticRouteDefinition } from '../../contexts'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export enum RouteNames {
  History = 'me.orders',
  Order = 'me.order'
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const ordersModuleStaticRoutes: StaticRouteDefinition[] = buildStaticRoutesDefinitions(
  'orders',
  Object.values(RouteNames)
)

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const routesFactory: RoutesFactory = (): RouteConfig[] => {
  return [
    {
      path: '/account/orders',
      name: RouteNames.History,
      meta: { auth: true, metaTitle: 'My orders', static: true },
      component: () => import(/* webpackChunkName: "orders/view" */ './views/Orders.vue')
    },
    {
      path: '/account/order/:id',
      name: RouteNames.Order,
      meta: { auth: true, metaTitle: 'Order', static: true },
      component: () => import(/* webpackChunkName: "orders/view" */ './views/Order.vue')
    }
  ]
}
